import { PowerCell } from '~/services/plugins/power-cell/components';
import { twMerge } from 'tailwind-merge';
import { getVideoDetailCellPluginConfigurationIds } from './utils/get-video-detail-cell-plugin-configuration-ids';

type VideoDetailProps = {
  entry: any;
  styles: Record<string, any>;
};

/**
 * The video details is part of the player configuration and will always appear
 * directly under the video.
 * This component will be shown only when enable_inline_mode is true.
 */
export function VideoDetail({ entry, styles }: VideoDetailProps) {
  const isInlineModeEnabled = Boolean(styles?.enable_inline_mode);

  const visibilityClasses = twMerge(
    isInlineModeEnabled && styles?.enable_video_detail_mobile
      ? 'mobile:max-tablet:block'
      : 'mobile:max-tablet:hidden',
    isInlineModeEnabled && styles?.enable_video_detail_tablet
      ? 'tablet:max-desktop:block'
      : 'tablet:max-desktop:hidden',
    isInlineModeEnabled && styles?.enable_video_detail_desktop
      ? 'desktop:max-large-desktop:block'
      : 'desktop:max-large-desktop:hidden',
    isInlineModeEnabled && styles?.enable_video_detail_large_desktop
      ? 'large-desktop:block'
      : 'large-desktop:hidden'
  );

  const { mobileCellId, tabletCellId, desktopCellId, largeDesktopCellId } =
    getVideoDetailCellPluginConfigurationIds(styles);

  const uiComponent = {
    id: 'video-detail',
    styles: {
      mobile_cell_plugin_configuration_id: mobileCellId,
      tablet_cell_plugin_configuration_id: tabletCellId,
      desktop_cell_plugin_configuration_id: desktopCellId,
      large_desktop_cell_plugin_configuration_id: largeDesktopCellId,
    },
  };

  return (
    <section
      className={twMerge(
        'video-detail player-fullscreen-hide-video-detail video-detail-classes',
        'flex h-fit w-full shrink-0 flex-col overflow-x-auto overflow-y-hidden border-none scrollbar-hide',
        visibilityClasses
      )}
    >
      <div className="video-detail-max-width-classes">
        <PowerCell
          // @ts-ignore
          uiComponent={uiComponent}
          entry={entry}
          selectable={false}
          isLoading={false}
        />
      </div>
    </section>
  );
}
